// "Spot the Slip" expansion — IDENTITY theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_IDENTITY = [
  ["Eu sou aborrecido nas festas longas.", "Eu estou aborrecido nas festas longas.", "ser-estar",
    "A passing mood (bored right now) takes estar; ser aborrecido means 'boring'.", "ser-vs-estar"],
  ["A minha amiga é doente hoje.", "A minha amiga está doente hoje.", "ser-estar",
    "Being ill is a temporary condition → estar.", "ser-vs-estar"],
  ["Ele é da Noruega mas está norueguês desde sempre.", "Ele é da Noruega e é norueguês.", "ser-estar",
    "Nationality is an essential identity trait → ser, not estar.", "ser-vs-estar"],
  ["A mulher é muito simpático.", "A mulher é muito simpática.", "gender",
    "Adjectives agree with the noun: feminine subject → simpática.", "adjective-agreement"],
  ["É uma homem alto.", "É um homem alto.", "gender",
    "Homem is masculine; pair it with um, not uma.", "gender-agreement-of-nouns"],
  ["A minha irmã é muito falador.", "A minha irmã é muito faladora.", "gender",
    "A feminine subject needs the feminine form faladora.", "adjective-agreement"],
  ["Eu chamo-me é Pedro.", "Eu chamo-me Pedro.", "basics",
    "Chamar-se already means 'to be called'; don't add 'é'.", ""],
  ["Tenho trinta anos velho.", "Tenho trinta anos.", "basics",
    "Age uses ter + anos with no word for 'old'.", ""],
  ["Eu gosto de as pessoas educadas.", "Eu gosto das pessoas educadas.", "gustar",
    "Gostar takes de; de + as = das.", "gostar-and-similar-verbs"],
  ["Ontem o meu avô falecia depois de uma longa vida.", "Ontem o meu avô faleceu depois de uma longa vida.", "preterito-imperfecto",
    "A single, completed event takes the pretérito perfeito → faleceu.", "a2-preterito-vs-imperfeito"],
  ["Quando era jovem, fui sempre muito tímido.", "Quando era jovem, era sempre muito tímido.", "preterito-imperfecto",
    "An ongoing trait in the past is the imperfeito → era.", "a2-preterito-vs-imperfeito"],
  ["O meu carater é calmo.", "O meu caráter é calmo.", "accents",
    "Caráter is paroxytone ending in -r, so it takes an acute on the á.", "stress-and-written-accents"],
  ["Ele é portugues e fala três línguas.", "Ele é português e fala três línguas.", "accents",
    "Português is oxytone ending in -s; the stressed e takes a circumflex.", "stress-and-written-accents"],
  ["Quero que o meu filho é educado.", "Quero que o meu filho seja educado.", "subjunctive",
    "A wish about someone else (querer que) triggers the conjuntivo → seja.", "b1-present-subjunctive"],
  ["É importante que tu te defines com honestidade.", "É importante que tu te definas com honestidade.", "subjunctive",
    "Impersonal 'é importante que' takes the conjuntivo → te definas.", "b1-present-subjunctive"],
];
